import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";
import { ClaimApiType } from "./types/apiTypes";

const claimApi: ClaimApiType = {
  get: (value) => apiClient.get(endPoints.claim.get(value)),
  getClaimsView: (payload) =>
    apiClient.get(endPoints.claim.getClaimsView(), payload),
  searchClaims: (payload) =>
    apiClient.post(endPoints.claim.searchClaims(), payload),
  save: (payload) => apiClient.post(endPoints.claim.save(), payload),
  delete: (value) => apiClient.delete(endPoints.claim.delete(value)),
  activate: (value) => apiClient.post(endPoints.claim.activate(value)),
};

export default claimApi;
